import ApiService from './ApiService';

export default class CapacitieApi extends ApiService {
    constructor() {
        super('capacitie');
    }

    getCapacitieList(payload) {
        return this.get('', payload);
    }
}
